/**
 * 正品项目接口集合
 */
import request from './request'
export default {
  /**
   * 防伪查询模块
   * 验证查询码
   */
  validateQueryCode: (queryCode) => {
    const url = `/redstarzp/app/redstar/ValidateBrandByQueryCode/${queryCode}`
    return request.get(url)
  },
  /**
   * 防伪查询模块
   * 验证防伪码
   */
  validateProduct: (postData) => {
    const url = '/redstarzp/app/redstar/ValidateProduct'
    return request.post(url, postData)
  },
  /**
   * 联盟成员查询
   */
  getAllianceList: (postData) => {
    const url = '/redstarzp/app/redstar/getAllianceList'
    return request.post(url, postData)
  },
  /**
   * 领跑品牌类型
   */
  getLeadBrandCatogory: () => {
    // http://greenleader.chinaredstar.com
    const url = 'http://greenleader.chinaredstar.com/hxmkl-mall-system/rest/basic/class/ad'
    return request.get(url)
  },
  /**
   * 获得该类型下的品牌
   */
  getBrands: (postData) => {
    // http://greenleader.chinaredstar.com
    const url = 'http://greenleader.chinaredstar.com/hxmkl-mall-system/rest/reward/ad'
    return request.post(url, postData)
  },
  /**
   * 由查询码查询品牌
   */
  getBrandByCode: (postData) => {
    // http://greenleader.chinaredstar.com
    const url = 'http://greenleader.chinaredstar.com/hxmkl-mall-system/rest/reward/ad/sreach'
    return request.post(url, postData)
  },
  /**
   * 留言
   */
  submitJoinUs: (postData) => {
    // http://greenleader.chinaredstar.com
    const url = '/redstarzp/app/redstar/submitJoinUs'
    return request.post(url, postData)
  }
}



// WEBPACK FOOTER //
// ./src/api/pcServer.js